import React from 'react'
import {CampanyDataWrapper} from './styles'
export const CampanyData = () => {
  return (
    <CampanyDataWrapper>
      <table>
      <tr>
      <th>運営会社</th>
      <td>株式会社JGlobal</td>
      </tr>
      <tr>
      <th>所在地</th>
      <td>〒210-0855 神奈川県川崎市川崎区南渡田町1番3号 川崎港郵便局1 階</td>
      </tr>
      <tr>
      <th>法人番号</th>
      <td>8020001052576</td>
      </tr>
      <tr>
      <th>内容</th>
      <td>飲食店経営　屋号「韓国料理どやじ 」</td>
      </tr>   
      </table> 
    </CampanyDataWrapper>
  )
}

